import { makeRequest } from '@monjin/data';
import { fetchBody } from '@monjin/data/util';

export function validateShare(suid: string): Promise<any> {

    const url = `/api/validate-share`;

    const body = {
        shareCode: suid
    };

    return fetchBody(makeRequest('POST', url, body));
}
